export default __webpack_public_path__ + "static/media/logo_helpscout.885d758f.svg";